<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <span class="title">Disposition Details</span>
      @if (
        !!projectDetail?.permission?._edit ||
        !!dispositionDetail?.permission?._edit
        ) {
        <button
          class="save-button"
          (click)="saveDetails()">
          <mat-icon>save</mat-icon>
        </button>
      }
    </mat-card-title>
  </mat-card-header>
  @if (dispositionDetail && projectDetail) {
    <mat-card-content>
      <form action mat-form>
        <ul>
          <li>
            <span class="label">Fully Disposed</span>
            @if (!!projectDetail.permission?._edit) {
              <simple-checkbox
                label=""
                name="fully_disposed"
                [checked]="projectDetail.fully_disposed ?? null"
            (checkedChange)="
              projectDetail.fully_disposed = !projectDetail.fully_disposed
            ">
              </simple-checkbox>
            }
            <ng-container
            *ngTemplateOutlet="
              !projectDetail.permission?._edit ? valueSpan : nothing;
              context: {
                value:
                  projectDetail.fully_disposed === null ||
                  projectDetail.fully_disposed === undefined
                    ? ''
                    : projectDetail.fully_disposed
                    ? 'Yes'
                    : 'No'
              }
            ">
          </ng-container>
        </li>
        <li>
          <span class="label">Active GP Transfer</span>
          <select
            name="disposition_gp_transfer_status_id"
            [disabled]="!dispositionDetail.permission?._edit"
            [(ngModel)]="dispositionDetail.disposition_gp_transfer_status_id">
            <option [value]="null">&mdash;</option>
            @for (
              dispositionGpStatus of dispositionDetailService.dispositionGpTransferStatuses$
              | async
              ; track
              dispositionGpStatus) {
              <option
                [value]="dispositionGpStatus.id">
                {{ dispositionGpStatus.name }}
              </option>
            }
          </select>
        </li>
        <li>
          <span class="label">Active Refinancing</span>
          <select
            name="disposition_refinancing_status_id"
            [disabled]="!dispositionDetail.permission?._edit"
            [(ngModel)]="dispositionDetail.disposition_refinancing_status_id">
            <option [value]="null">&mdash;</option>
            @for (
              dispositionRefinancingStatus of dispositionDetailService.dispositionRefinancingStatuses$
              | async
              ; track
              dispositionRefinancingStatus) {
              <option
                [value]="dispositionRefinancingStatus.id">
                {{ dispositionRefinancingStatus.name }}
              </option>
            }
          </select>
        </li>
        <li>
          <span class="label">Forced Sale Right</span>
          @if (!!dispositionDetail.permission?._edit) {
            <nullable-boolean
              name="forced_sale_right"
              [value]="dispositionDetail.forced_sale_right"
            (valueChange)="
              dispositionDetail.forced_sale_right = $event
            "></nullable-boolean>
          }
          <ng-container
            *ngTemplateOutlet="
              !dispositionDetail.permission?._edit ? valueSpan : nothing;
              context: {
                value:
                  dispositionDetail.forced_sale_right === null
                    ? ''
                    : dispositionDetail.forced_sale_right
                    ? 'Yes'
                    : 'No'
              }
            ">
        </ng-container>
      </li>
    </ul>
    <h3>Notes</h3>
    <textarea
      name="disposition_notes"
      [disabled]="!dispositionDetail.permission?._edit"
      [(ngModel)]="dispositionDetail.disposition_notes">
    </textarea>
  </form>
</mat-card-content>
}
</mat-card>
<ng-template let-value="value" #valueSpan>
  @if (value?.length) {
    <span class="value">{{ value }}</span>
  } @else {
    <span class="value">&mdash;</span>
  }
</ng-template>
<ng-template #nothing></ng-template>
